import React, { useRef } from 'react';
import ControlSwitch from '@/Shared/Form/ControlSwitch';
import { useFormContext, useWatch } from 'react-hook-form';
import Input from '@/Shared/Form/Input';

const PublicSources = () => {
  const { control } = useFormContext();
  const isSelected = useWatch({ name: 'publicSources', control });

  return (
    <React.Fragment>
      <div className="mb-3">
        <ControlSwitch
          labelOff='No'
          labelOn='Yes'
          name='publicSources'
        />
      </div>
      {isSelected && (
        <Input
          isRequired
          labelText='Please specify the source of the personal data'
          name='publicSourceValue'
          type='text'
        />
      )}
    </React.Fragment>
  );
};

export default PublicSources;